<template>
  <div class="md-layout anual-pricing">
    <div class="md-layout-item md-medium-size-100 md-size-40 zindex3">
      <filters v-on:applyFilters="loadData" @change="resetRows"></filters>
    </div>
    <div class="md-layout-item md-size-100">
      <data-table ref="table" :endpoints="endpoints" :getCellAttrs="getCellAttrs" units="€" paginationEnabled> </data-table>
    </div>
  </div>
</template>

<script>
import DataTable from './Components/ComputedTablePricing.vue'
import Filters from './Components/PricingFilters.vue'

import Api from '../../../../openapi/src/api/InitialPriceApi'
import InitialPriceDataDTO from '../../../../openapi/src/model/InitialPriceDataDTO'

const api = new Api()

export default {
  components: {
    Filters,
    DataTable,
  },
  data() {
    return {
      endpoints: {
        compute: api.fetchInitialPrice.bind(api),
        save: api.saveInitialPrice.bind(api),
        create: (data) => InitialPriceDataDTO.constructFromObject(data),
      },
    }
  },
  methods: {
    getCellAttrs(filters) {
      return ['retail_price', 'minimum_price', 'maximum_price']
    },
    loadData(filters) {
      this.$refs['table'].loadData(filters)
    },
    resetRows() {
      this.$refs['table'].clear()
    },
  },
}
</script>
<style lang="scss">
.zindex3 {
  z-index: 3;
}
</style>
